import { client } from '@/common-utils/libraries/axios/axios';
import { ENVELOPES } from '../apiUrls';

const mutationDeprogramEnvelopes = (onSuccess, onError) => {
    return {
        mutationFn: ({ envelopesIds }) => {
            return client.delete(ENVELOPES.DEPROGRAM.url, { data: envelopesIds });
        },
        // onError: (error, variables, context)
        onError: (error) => {
            onError(error);
        },
        // onSuccess: (data, variables, context)
        onSuccess: (data) => {
            onSuccess(data);
        },
        // onSettled: (data, error, variables, context)
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationDeprogramEnvelopes;